import React, { useEffect } from 'react';
import { registerServiceWorker } from '@/lib/service-worker';

export const ServiceWorkerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    // Service Worker für Push Notifications aktivieren
    // Version 5 verwendet Network-first Strategie, cached keine API-Calls oder Admin-Bereich
    if ('serviceWorker' in navigator) {
      void registerServiceWorker();
    }
  }, []);

  return <>{children}</>;
};
